import React from "react";

import Counter from "./Counter";
import Probe from "./Probe";
import { SENSOR_TYPE } from "../../../../../../domain/sensor";

const Sensor = React.memo(props => {
  const { sensor } = props;

  if (sensor.type === SENSOR_TYPE.COUNTER) {
    return <Counter {...props} />;
  }

  return <Probe {...props} />;
});

export default Sensor;
